<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content >
    <div class="row">
        <div class="col-sm-12" style="margin-top: 100px;">
            <div class="lkl">
                <div class="gfg_ig_ht">
                    <div class="pcg_img">
                        <a href="javascript:void(0)" class="card-icon">
                            <img [src]="profileData.profileThumbImg" alt="" onerror="this.src='../../../../assets/images/user-avatar.svg'">
                        </a>
                        <div class="un_ld_img" (click)="triggerFileInput.click()">
                            <a href="javascript:void(0)">
                                <mat-icon style="font-size: 25px;
                                color: #ffc107;
                                position: relative;
                                top: 4px; left: -1px;">add_a_photo</mat-icon>
                                <input #triggerFileInput type="file" accept="image/*" name="img" id="imagepick" class="upload" (change)="onUploadImage($event)">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div style="text-align: center;
    margin-bottom: 40px">
        <span class="card-icon ">
            <img src="../../../../assets/images/user-avatar.svg" alt="" onerror="this.src='../../../../assets/images/salon_support_header.png'">
          </span>
          <div style="position: absolute;
          right: 670px;
          cursor: pointer;
          top: 300px;">
            <mat-icon style="font-size: 30px;">add_a_photo</mat-icon>
          </div>
          
    </div> -->
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input
          [(ngModel)]="profileData.name"
          matInput
          #input
          (ngModelChange)="changeRates()"
        />
      </mat-form-field>
    </div>
    <div >
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker0.open()" style="padding: 0px;">
            <mat-label>Select Date</mat-label>
            <input matInput [matDatepicker]="picker0" [(ngModel)]="profileData.dateOfBirth" readonly >
    
            <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
            <mat-datepicker #picker0 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Phone Number</mat-label>
        <input
          [(ngModel)]="profileData.toshowPhone"
          matInput
          #input
          disabled="true"
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input
        [(ngModel)]="profileData.email"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Gender: </label>
        <mat-radio-group [(ngModel)]="profileData.gender">
          <mat-radio-button value="Male">Male</mat-radio-button>
          <mat-radio-button value="Female">Female</mat-radio-button>
          <mat-radio-button value="Others">Others</mat-radio-button>
        </mat-radio-group>
      </div>      
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Bio Info</mat-label>
          <textarea
            [(ngModel)]="profileData.shortBio"
            matInput
          ></textarea>
        </mat-form-field>
      </div>
      <div >
        <mat-form-field appearance="outline">
          <mat-label>Location</mat-label>
          <input
          (input)="updateSearchResults()"
          placeholder="Select a location"
            [matAutocomplete]="auto"
            [(ngModel)]="this.profileData.addressInfo.address_line"
            matInput
            #input
          />
              <mat-autocomplete #auto="matAutocomplete" >
                          <mat-option
                            *ngFor="let item of autocompleteItems"
                            (click)="selectSearchResult(item)"
                          >
                            {{ item.description }}
                          </mat-option>
                        </mat-autocomplete>
        </mat-form-field>
      </div>
  </mat-dialog-content>
<!-- 
  <mat-dialog-content *ngIf="editMode">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input
          [(ngModel)]="editCreditData.amount"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Status: </label>
        <mat-radio-group [(ngModel)]="editCreditData.status">
          <mat-radio-button [value]="1">Active</mat-radio-button>
          <mat-radio-button [value]="0">Paid Fully</mat-radio-button>
        </mat-radio-group>
      </div>
  </mat-dialog-content> -->
  
  <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      
      (click)="onPost()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
  